import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

const Faq = ({ items }: { items: { q: string; a: string }[] }) => (
  <Accordion type="multiple" className="reveal divide-y divide-rule border-y border-rule">
    {items.map((item) => (
      <AccordionItem key={item.q} value={item.q} className="border-0">
        <AccordionTrigger className="py-6 text-left font-serif text-2xl font-normal hover:text-goldcore hover:no-underline [&>svg]:text-goldcore">
          {item.q}
        </AccordionTrigger>
        <AccordionContent className="pb-6 text-base leading-relaxed text-mist">{item.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export default Faq;
